module.exports = __webpack_public_path__ + "static/media/pana.3a70b626.png";